module.exports = __webpack_public_path__ + "static/media/Selectdish.306bc63b.png";